import {combineReducers} from 'redux'
import {
    SIGN_IN
} from './actions';
//------------------------------------------------------------
export const signInReducer=(state=false,action)=>{
    const {type,payload}=action;
    switch(type){
        case SIGN_IN:{
            return payload
        }
        default:
            return state;
    }
}

//-------------------------------------------------------------------
export default combineReducers({
isSignedIn:signInReducer
})